import { GrowpIcon } from 'packages/components/GrowpIcon'
import { PermEnum } from 'packages/sdks-next/growp'
import { MenuItemUnion } from 'packages/web-layout/types'

export const useAdmissionsMenu: () => MenuItemUnion[] = () => {
  return [
    {
      path: '/admin/admissions',
      label: (
        <GrowpIcon
          name="User"
          text="招生招聘"
          size={14}
          textMarginLeft={16}
        />
      ),
      labelText: '招生招聘',
      height: 40,
      perm: PermEnum.InformalReflection,
    },
  ]
}
